/**
 * Pure predicates that decide how sendDraftMessage in useChatProcessing
 * publishes messages relative to in-flight uploads. PR #4946 (TA-9526)
 * was the canonical regression: a message with one pending upload was
 * published with publish:true and documents:[], leaving it stuck. The
 * computation that decides publish-vs-pending is exactly these three
 * predicates.
 */

/**
 * Should the mutation set publish:true? True when there are no documents
 * at all (text-only message) OR every document has finished uploading.
 *
 * Critical: this returns false the moment a single upload is still pending.
 * Sending publish:true with an incomplete documents array is the bug
 * #4946 fixed.
 */
export const shouldPublishMessage = (
  totalDocuments: number,
  uploadFinishedDocuments: number
): boolean => totalDocuments < 1 || totalDocuments === uploadFinishedDocuments;

/** True when there are documents AND every one has a blobId. */
export const allUploadsCompleted = (
  totalDocuments: number,
  uploadFinishedDocuments: number
): boolean => totalDocuments > 0 && totalDocuments === uploadFinishedDocuments;

/** True when at least one document is still uploading (no blobId yet). */
export const hasPendingUploads = (
  totalDocuments: number,
  uploadFinishedDocuments: number
): boolean => totalDocuments > 0 && uploadFinishedDocuments < totalDocuments;
